import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import HeroImage from '../../assets/hero-product-image.png'; // rename to match your asset
import {
  HeroWrapper,
  HeroTextCol,
  HeroImageCol,
  HeroTitle,
  HeroButton,
  HeroText
} from './Hero.styled';
import { useNavigate } from 'react-router';

const Hero = () => {
  const navigate = useNavigate();
  
  return (
    <HeroWrapper fluid>
      <Row>
        <HeroTextCol xs={12} md={5}>
          <HeroTitle>Produk Berkualitas Tinggi<br />Untuk Setiap Momen</HeroTitle>
          <HeroText>
            Solusi kemasan yang aman dan fungsional untuk industri F&B,
            dengan standar produksi terbaik dan pengiriman tepat waktu.
          </HeroText>
          <HeroButton onClick={() => navigate('/products?category=all-products')}>Semua Produk</HeroButton>
        </HeroTextCol>
        <HeroImageCol xs={12} md={7}>
          <img src={HeroImage} alt="Hero" />
        </HeroImageCol>
      </Row>
    </HeroWrapper>
  );
};

export default Hero;